import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useHistory } from 'react-router-dom';
import useTypedSelector from 'signin-app/components/hooks/use-typed-selector';
import { getSiteId } from 'signin-app/login/selectors';
import RoutesMap from 'signin-app/routes/routes-map';
const GuestEntryButton = React.lazy(() => import('@famly/nux_signin-guest_business-logic').then(module => ({ default: module.GuestEntryButton })));
// Reads the site from the same Redux login state as GuestScreen, so the button never opens a flow
// the route would bounce straight back out of.
export const GuestEntry = ({ returnTo }) => {
    const history = useHistory();
    const siteId = useTypedSelector(getSiteId);
    if (!siteId) {
        return null;
    }
    return (_jsx(React.Suspense, { fallback: null, children: _jsx(GuestEntryButton, { siteId: siteId, onOpen: () => history.replace({ pathname: RoutesMap.guest, state: { returnTo } }) }) }));
};
